/* eslint-disable import/no-anonymous-default-export */
// console.log(`NODE_ENV is set to: ${process.env.NODE_ENV}`);
const currentHostname =
  typeof window !== "undefined" ? String(window.location.hostname || "").toLowerCase() : "";
const isLocalHost =
  process.env.NODE_ENV === "development" ||
  currentHostname === "localhost" ||
  currentHostname === "127.0.0.1" ||
  currentHostname.endsWith(".localhost.com");
const isStagingHost = currentHostname === "hrmsstaging.cherrypiksoftware.com";
const configuredApiUrl = (process.env.REACT_APP_API_URL || "").trim();
const resolvedApiUrl = configuredApiUrl
  ? configuredApiUrl.replace(/\/?$/, "/")
  : isLocalHost
    ? "http://cspi-ems-api.localhost.com/"
    : isStagingHost
      ? "https://hrmsstagingapi.cherrypiksoftware.com/"
      : "https://hrmsapi.cherrypiksoftware.com/";

export default {
  // apiurl: process.env.NODE_ENV === "development"
  // ? "http://cspi-ems-api.localhost.com/"
  // : process.env.NODE_ENV === "testing"
  // ? "hrmsstagingapi.cherrypiksoftware.com/" 
  // : "https://hrmsapi.cherrypiksoftware.com/",

  // apiurl: process.env.NODE_ENV === "development"
  //   ? "http://cspi-ems-api.localhost.com/"
  //   // : "https://hrmsapi.cherrypiksoftware.com/",  
  //   // : "http://hrmsstagingapi.cherrypiksoftware.com/",
  //   : "https://hrms.cherrypiksoftware.com/",

  // testapiurl: process.env.NODE_ENV === "staging"
  //   ? "http://cspi-ems-api.localhost.com/"
  //   // : "https://hrmsapi.cherrypiksoftware.com/",
  //   // : "http://hrmsstagingapi.cherrypiksoftware.com/",
  //   : "https://hrms.cherrypiksoftware.com/",
  // // apiurl: process.env.NODE_ENV === "development"
  // //   ? "http://cspi-ems-api.localhost.com/"
  // //   : process.env.NODE_ENV === "production"
  // //     ? "http://hrmsstagingapi.cherrypiksoftware.com/"
  // //     : "https://hrmsapi.cherrypiksoftware.com/",
  apiurl: resolvedApiUrl,

  testapiurl: resolvedApiUrl,

  authApis: {
    login: "api/auth/login",
    logout: "api/auth/logout",
    refreshToken: "api/auth/refresh",
    gmailotp: "api/send-otp",
    verifyotp: "api/verify-otp",
    resetpassword: "api/reset-password",
    getLoginContent: "api/auth/login-content",
  },
  apis: {
    userList: "api/users",
    saveLoginContent: "api/save-login-content",
    authUser: "api/users/me",
    userInTime: "api/emp/in-time",
    userOutTime: "api/emp/out-time",
    getPermission: "api/permission",
    createPermission: "api/permission",
    updatePermission: "api/permission/",
    deletePermission: "api/permission/remove/",
    getRole: "api/role",
    editRole: "api/roles/",
    createRole: "api/role",
    deleteRole: "api/role/remove/",
    deleteUser: "api/users/remove/",
    updateRole: "api/role/",
    updateImg: "api/upload",
    deleteImg: "api/remove-file",
    createUser: "api/users/create",
    editUser: "api/users/update/",
    singleUser: "api/users/",
    dureTime: "api/emp/totalDurationTime/",
    dureTime1: "api/emp/totalDurationTime/show/",
    holidayLeave: "api/holiday-leave",
    removeLeave: "api/holiday-leave/",
    eidtLeave: "api/holiday-leave/",
    singleLeave: "api/holiday-leave/",
    createTicket: "api/leave",
    EditTicket: "api/leave/update-status/",
    singleTicket: "api/leave/edit-status/",
    getAttandance: "api/users/get-working-duration/",
    AllgetAttandance: "api/working-duration/all-users/",
    getEvent: "api/event/",
    createEvent: "api/event",
    DeleteEvent: "api/event/",
    singleEvent: "api/event/",
    editEvent: "api/event/",
    removeImage: "api/removeEventImage/",
    createCalendarEvent: "api/calendar-event",
    updateCalendarEvent: "api/calendar-event/",
    deleteCalendarEvent: "api/calendar-event/",
    deleteLeaveTicket: "api/leave-ticket/",
    createUpcomingEvent: "api/upcomingevent",
    uploadEventImg: "api/uploadEventFile",
    getAllEvent: "api/upcomingevent",
    getallAttendance: "api/user-monthly-report/",
    getAttendance: "api/monthly-report/",
    getdailylog: "api/user-daily-report/",
    getalldatadailylog: "api/all-users-daily-report/",
    AllDeleteEvent: "api/upcomingevent/",
    singleUpcomingEvent: "api/upcomingevent/",
    EditupcomingEvent: "api/upcomingevent/",
    deleteUpcomingImage: "api/removeEventFile",
    addSalary: "api/users/add-salary/",
    AllSalarydata: "api/user/salary/",
    AllSalaryPdf: "api/download-salary-slip",
    AllSalaryview: "api/view-salary-slip",
    createjob: "api/job/create",
    getAllJob: "api/job/show",
    deletejob: "api/job/delete/",
    singlejob: "api/job/show/",
    editjob: "api/job/update/",
    getQulification: "api/qualification/show",
    createQulification: "api/qualification/create",
    deleteQulification: "api/qualification/delete/",
    singleQulification: "api/qualification/show/",
    editQulification: "api/qualification/update/",
    getExperience: "api/experience/show",
    createExperience: "api/experience/create",
    deleteExperience: "api/experience/delete/",
    singleExp: "api/experience/show/",
    editExperience: "api/experience/update/",
    bdayNotification: "api/employeebdynotification/show",
    addTime: "api/timeEntry/addtime/",
    chekUserData: "api/timeEntry/show",
    approveTime: "api/timeEntry/updateStatus/",
    alldatasalary: "api/user/getalldatasalary",
    alldatasalaryid: "api/user/getalldatasalarybyid/",
    userstatus: "api/update/userstatus",
    NotificationStatus: "api/update/NotificationStatus",
    BreakNotificationStatus: "api/update/BreakNotificationStatus",


    offerletteradd: "api/offerLetter",
    getEmpleaves: "api/leave",
    getleaves: "api/allleave",
    EditTickets: "api/leave-ticket/",
    allinout: "api/unapproved-in-out-data",
    // offerletterdo: "api/offer-letterdo/",
    // offerletterview: "api/offer-letter-view-pdf/",
    // offerletterdelete: "api/offer-letters/",
    previewofferletter: "api/offer/previewofferletter/",
    Templatepostdata: "api/template",
    Templategetstatu: "api/update/templatestatus",
    Templategeedit: "api/templates/",
    Templateupdate: "api/templates/",
    Templatedelete: "api/template/",
    // Templatedit:"api/templates/",
    // Relievingletter
    Relievingletterget: "api/resign-letters",
    Templategetdata: "api/templates",
    offerletter: "api/offer/letter",
    Relievingletterpost: "api/resignLetter",
    Relievingletterdelete: "api/resign-letters/",
    Relievingletterdo: "api/download-resign-letter/",
    Relievingletterview: "api/view-resign-letter/",
    relivingletter: "api/resign-letter/update-status",
    Notification: "api/admin/notifications",
    NotificationEmployee: "api/employee/notifications",
    Notificationread: "api/notifications/",
    Notificationview: "api/notifications/view/",
    viewSalaryPdf: "api/view-salary-pdf",
    // getEmpleaves: "api/leave",
    // getleaves: "api/allleave",
    offerletterdo: "api/download-offer-letter/",
    offerletterview: "api/view-offer-letter/",
    offerletterdelete: "api/offer-letters/",
    offerlattertemplaye: "api/download-offer-letter/",
    // relivingletter: "api/resign-letter/update-status",
    // viewSalaryPdf: "api/view-salary-pdf",
    Salarydelete: "api/salary-slip/",
    Addsalaryall: "api/cron/add-salaryslip",
    calculateworking: "api/cron/calculate-working-hrs",
    cronlogs: "api/cron-logs",
    cronlogsdelete: "api/cron-logs/delete/",
    userimg: "api/logged-user-image",
    getpermissions: "api/get/permissions",
    // settings apis
    getnotificationicons: "api/get-notification-icons",
    savenotificationicons: "api/notification-icons",
    saveWorkingHours: "api/save-working-hours",
    getWorkingHours: "api/working-hours",
    saveleavebalance: "api/save-leave-balance",
    getleavebalance: "api/get-leave-balance",
    //view profile
    userimgid: "api/logged-user-image/",
    userreportAttendance: "api/user-report/",
    getUserReportByDateRange: "api/getUserReportByDateRange/",
    leavetickets: "api/leave-tickets/",
    Readedemployeenotifications: "api/employee/readednotifications",
    Readedadminnotifications: "api/admin/readednotifications",
    ShowMissingTimeEntriesById: "api/time-entries/",
    TimeEntrshowuser: "api/time-entry-showbyid/",
    Updartetimeentry: "api/time-entry/",
    deletetimeentry: "api/empinout/force-delete/",
    savesections: "api/save-sections-order",
    getsections: "api/get-sections-order",
    alllettersget: "api/letters/",
    addlettersFieldata: "api/letters/",
    dynamicletterdownload: "api/download",
    dynamicletterview: "api/view",
    dynamicletterdelete: "api/dynamicletters/",
    fetchUserRole: "api/current-user-role",
    toggleRole: "api/toggle-role/",
    salarydetailsdownload: "api/salary-details/download/",
    designationcreate: "api/designation/create",
    designationhow: "api/designation/show",
    designationdelete: "api/designation/delete/",
    Designationhowbyid: "api/designation/showbyid/",
    designationupdate: "api/designation/update/",
    Departmentcreate: "api/department/create",
    Departmentshow: "api/department/show",
    Departmentdelete: "api/department/delete/",
    Departmenthowbyid: "api/department/showbyid/",
    Departmentupdate: "api/department/update/",
    userleave: "api/getLeaveAndAbsentStatus",

    adminnotifiwise: "api/admin-read-type-wise/",
    employeenotifiwise: "api/employee-read-type-wise/",

    notificationsalladmin: "api/mark-fetched-admin-read",
    notificationsallemployee: "api/mark-fetched-employee-read",



    Reviewformadd: "api/add-form",
    Reviewformdelete: "api/delete-form/",
    Reviewformupdate: "api/update-form/",
    Reviewformlist: "api/getforms",
    ReviewformlistgetformbyID: "api/get-formbyID/",

    Reviewformdynamicadd: "api/forms/",
    Reviewformdynamiclistid: "api/getFormsByUserId/",
    Reviewformdynamiclist: "api/forms",
    Reviewformdynamicdelete: "api/dynamicforms-delete/",
    Reviewformdynamicupdate: "api/dynamicforms-update/",

    breaktimeadd: "api/set-do-not-disturb",
    breaktimeedit: "api/get-do-not-disturb-times",
    breaktimeremainder: "api/remind-clock",

    emailtemplateadd: "api/addemailtemplate",
    emailtemplateupdate: "api/updatemailtemplate/",
    emailtemplategetbyid: "api/emailtemplatebyid/",
    emailtemplatedelete: "api/deleteemailtemplate/",
    emailtemplategetall: "api/emailtemplates",
    emailtemplatestatus: "api/updateemailtemplatestatus",

    reviewformstatus: "api/update/reviewformstatus",


    createtask: "api/create-task",
    taskslist: "api/tasks",
    taskslistbyuserid: "api/tasks/auth-user",
    taskedit: "api/tasks/",
    taskupdate: "api/Updatetask/",
    taskdelete: "api/deletetask/",

    // project apis
    getProject: "api/project/show",
    createProject: "api/project/create",
    deleteProject: "api/project/delete/",
    singleProject: "api/project/show/",
    editProject: "api/project/update/",
    // project issues (RESTful nested under project)
    // Compose as: `${apiurl}${apis.projectIssues}${projectId}/issues`
    projectIssues: "api/projects/",
    // project updates (RESTful nested under project)
    // Compose as: `${apiurl}${apis.projectUpdates}${projectId}/updates`
    projectUpdates: "api/projects/",
    updateMilestone: "api/milestones/", // + {id}
    deleteMilestone: "api/milestones/", // + {id}
    // project update comments (edit/delete will follow same base)
    // Compose as: `${apiurl}${apis.projectUpdateComments}${projectId}/updates/{updateId}/comments/{commentId}`
    projectUpdateComments: "api/projects/",
    // project activity and timeline
    // Compose as: `${apiurl}${apis.projectActivity}${projectId}/activity`
    // and `${apiurl}${apis.projectTimeline}${projectId}/timeline`
    projectActivity: "api/projects/",
    projectTimeline: "api/projects/",
    // project resources (RESTful nested under project)
    // Compose as: `${apiurl}${apis.projectResources}${projectId}/resources`
    projectResources: "api/projects/",
    updateTaskStatus: "api/update-task-status/",
    taskdeadlineupdate: "api/get-task-update-notifications",
    updateSubTaskStatus: "api/subtask-status/",
    getActivityLogs: "api/get-activity-logs/",
    updateProjectStatus: "api/project/statusupdate/",

    // clockinevents: 'api/clock-in-events',
    clockinevents: '',

    sendMessage: "api/chatify/send-message",
    getChatHistory: "api/chatify/get-message",
    getStatusColors: "api/get-status-colors",
    updateStatusColors: "api/working-hours/status-colors",
    carryforwardtimesave: "api/working-hours/carry-forward-expiry",

    leavebalanceuserwise: "api/leave-balances/user/",
    leavebalanceadmin: "api/leave-balances",
    checkWorkHours: "api/emp/check-work-hours",
    workingHoursAlertGet: "api/get-working-hours-alert-status/",
    workingHoursAlertSet: "api/set-working-hours-alert-status/",
    saveThemePreference: "api/user/theme-preference",
    getThemePreference: "api/user/theme-preference",
    getFrequentLatecomers: "api/frequent-latecomers",
    getLongBreaks: "api/long-breaks",
    dailyAttendanceStats: "api/daily-attendance-stats",
    employeePresenceMap: "api/employee-presence-map",
    dashboardCalendar: "api/dashboard-calendar"


  },
};
